import React from 'react'
import PrintBillReceipt from './PrintBillReceipt/PrintBillReceipt'
import ComponentPay from '../ComponentPay'
import { Pane } from 'evergreen-ui'


const StatusManageRegist_6 = ({ DataRegister }) => {
  return (
    <>
      <Pane display="flex" flexDirection="column" gap={5}>
        {/* พิมพ์ใบชำระเงินงวดที่ 2 */}
        <ComponentPay data={DataRegister} />
        {/* พิมพ์ใบเสร็จ */}
        <PrintBillReceipt DataRegister={DataRegister} />
      </Pane>
    </>

  )
}

export default StatusManageRegist_6